var $ = require('jquery');
const d3 = require("d3");
var ap_months = ["Jan.","Feb.","March","April","May","June","July","Aug.","Sept.","Oct.","Nov.","Dec."];
var commafy = s => (s * 1).toLocaleString().replace(/\.0+$/, "");
var commaFormat = d3.format(',');
//var monthTicks = ["3/1/2020", "4/1/2020", "5/1/2020", "6/1/2020", "7/1/2020","8/1/2020","9/1/2020","10/1/2020","11/1/2020","12/1/2020","1/1/2021", "2/1/2021", "3/1/2021", "4/1/2021", "5/1/2021", "6/1/2021", "7/1/2021", "8/1/2021", "9/1/2021", "10/1/2021", "11/1/2021", "12/1/2021", "1/1/2022", "2/1/2022", "3/1/2022", "4/1/2022","5/1/2022"];
const monthTicks = require("./monthTicks.js");
//////////////////////// TRENDS COUNTY CHART //////////////

 var conWidth = $("#barChart").width();
 var conHeight = (conWidth > 500) ? 350 : 220;


 var tooltip = d3.select(".counter .body");
 var dateBox = d3.select(".counter .head .date");

 var textBox = tooltip.append("div");
 var toolData = textBox.append("div").attr("class","toolData");


var margin = {top: 20, right: 0, bottom: 20, left: 70},
    width = conWidth - margin.left - margin.right,
    height = conHeight - margin.top - margin.bottom;

var x0 = d3.scaleBand().range([0, width]).padding(.05);

var x1 = d3.scaleBand().padding(.05);

var y = d3.scaleLinear()
    .range([height, 0]);

var xAxis = d3.axisBottom()
    .scale(x0)
    .tickValues(monthTicks)
    .tickFormat((d, i) => {
      var split_date = d.split("/");
      var year = split_date[2];
      year = year.slice(2);
      return `${split_date[0]}/${year}`;
    });

var yAxis = d3.axisLeft()
    .scale(y);

    xAxis.tickSizeOuter(0);




var svg = d3.select("#barChart").append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
  .append("g")
    .attr("class","mainG")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

var yBegin;
var caseColors = ["#F3C882", "#E98729", "#B75317", "#7b2003", "#360d01", '#aaa'];
var deathColors = ['#f6cac1', '#db8f87', '#ae5c5c', '#7c2f38', "#330107", '#aaa'];


var myFunction2 = function(updateData, idClicked) {
 var casesOrDeaths = (idClicked === "casesCounty2") ? "CasesTotal" : "DeathsTotal";

 var innerColumns = {
   "column1" : [ casesOrDeaths ]
 };

     var columnHeaders = d3.keys(updateData[0]).filter(function(key) { return (key === casesOrDeaths) });

     updateData.forEach(function(d) {
       var yColumn = new Array();
       d.columnDetails = columnHeaders.map(function(name) {
         for (ic in innerColumns) {
           if($.inArray(name, innerColumns[ic]) >= 0){
             if (!yColumn[ic]){
               yColumn[ic] = 0;
             }
             yBegin = yColumn[ic];
             yColumn[ic] += +d[name];
             return {name: name, column: ic, yBegin: yBegin, yEnd: +d[name] + yBegin,};
           }
         }
       });
       d.total = d3.max(d.columnDetails, function(d) {
         return d.yEnd;
       });
     });

     x0.domain(updateData.map(function(d) { return d.Date; }));
     x1.domain(d3.keys(innerColumns)).range([0, x0.bandwidth()]);

     y.domain([0, d3.max(updateData, function(d) {
       return d.total;
     })]);

     svg.selectAll(".axis").remove();

     svg.append("g")
         .attr("class", "x axis")
         .attr("transform", "translate(0," + height + ")")
         .call(xAxis);

     svg.append("g")
         .attr("class", "y axis")
         .call(yAxis)
       .append("text")
         .attr("transform", "rotate(-90)")
         .attr("y", 6)
         .attr("dy", ".7em")
         .style("text-anchor", "end")
         .text("");


     svg.selectAll(".g").remove();

     var project_stackedbar = svg.selectAll(".project_stackedbar")
         .data(updateData)
       .enter().append("g")
         .attr("class", "g")
         .attr("id", function(d,i) {
          if (i === (updateData.length - 1)) {
            var barID = (idClicked === "casesCounty2") ? "gLast" : "gLast2";
            return barID;
          } else { return ("g" + i) };
         })
         .attr("transform", function(d) { return "translate(" + x0(d.Date) + ",0)"; })
         .style("cursor","pointer")
         .on("click", function(d) {
           toolData.selectAll("div").remove();
           clickedDate = d.Date;
           clickedDate = clickedDate.split("/");
           var clickedMonth = parseInt(clickedDate[0]) - 1;
           dateBox.text(ap_months[clickedMonth] + " " + clickedDate[1] + ", " + clickedDate[2]);

           d3.selectAll('.g').style("opacity","0.5");
           d3.select(this).style("opacity","1");

           for (const key of Object.keys(d)) {
             if (d[key] > 0) {


               var countyName = key;

               // console.log(countyName);
               countyName = countyName.replace(/_/g, ' ');
               var countyCount = commaFormat(d[key]);
               var colorKey;
               var colorSet = (idClicked === "casesCounty2") ? "Case" : "Death";

              if ( countyName === "total" ) {
                var tspan1 = tooltip.select(".toolData").append("div").attr("class","entry");
                tspan1.html("<span class='count'>" + countyName + ": " + countyCount + "</span>" );
                tspan1.attr('x', 0).attr('dy', '1em');
              } else {}



             } else {}
           }
         });

     var bars = project_stackedbar.selectAll("rect")
         .exit()
         .remove()
         .data(function(d) {
           return d.columnDetails;
         })
         .enter().append("rect")
         .attr("width", x1.bandwidth())
         .transition()
         .duration(600)
         .attr("x", function(d) {
           return x1(d.column);
            })
         .attr("y", function(d) {
           return y(d.yEnd);
         })
         .attr("height", function(d) {
           return y(d.yBegin) - y(d.yEnd);
         })
         .style("fill", function(d) {
           var colorSet = (idClicked === "casesCounty2") ? caseColors : deathColors;
           if (d.name === "King") {
             return colorSet[0];
           } else if ( d.name === "Snohomish" ) {
             return colorSet[2];
           } else if ( d.name === "Pierce" ) {
             return colorSet[1];
          } else if ( d.name === "Yakima" ) {
            return colorSet[3];
         } else if ( d.name === "Unassigned" ) {
             return colorSet[5];
          } else { return colorSet[2]; }
        })
        .style("stroke", function(d) {
          var colorSet = (idClicked === "casesCounty2") ? caseColors : deathColors;
          if (d.name === "King") {
            return colorSet[0];
          } else if ( d.name === "Snohomish" ) {
            return colorSet[2];
          } else if ( d.name === "Pierce" ) {
            return colorSet[1];
         } else if ( d.name === "Yakima" ) {
            return colorSet[3];
          } else if ( d.name === "Unassigned" ) {
            return colorSet[5];
         } else { return colorSet[2]; }
       });

       if (idClicked === "casesCounty2") {
         d3.select('#gLast').dispatch('click');
       } else {
         d3.select('#gLast2').dispatch('click');
       }



 //});  // add paren after curly

}


// $( ".radioButton2" ).click(function() {
//   var thisID = $(this).attr("id");
//   $('.title').toggleClass("showMe");
//   if ( thisID === "casesCounty2" ) {
//     myFunction(dohNumbers, thisID);
//   } else {
//     myFunction(county_deaths, thisID);
//   };
// });
//
//
// myFunction(dohNumbers, "casesCounty2");


module.exports = myFunction2;
